import styles from "./styles.module.css";
import { useDrag } from "react-dnd";
import { getEmptyImage } from "react-dnd-html5-backend";
import { useEffect } from "react";

export default function CompCard({ comp }) {
  const [{ isDragging }, dragRef, preview] = useDrag({
    item: {
      type: "component",
      block: {
        component: comp.id,
        name: "new " + comp.name,
        props: {},
        children: [],
        dynamic: null,
        sources: null,
        stateVariables: null,
        custom: true,
      },
      kind: "Component",
      new: true,
    },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  });

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  }, []);
  return (
    <div
      style={{ borderColor: isDragging ? "var(--main)" : null }}
      ref={dragRef}
      className={styles.card}
    >
      <div className={styles.compCardText}>{comp.name}</div>
    </div>
  );
}
